import { getAccountService } from '../services/accountService';
import '../types/account.types';

/**
 * @returns {Partial<AccountType>} changes to be made to the account to revert any changes.
 */
// eslint-disable-next-line import/prefer-default-export
export async function cancelAddressEditing(accountKey, addressesEditModes) {
    const isAnyAddressEditable = Object.keys(addressesEditModes).some(key => addressesEditModes[key]);
    
    if (isAnyAddressEditable) {
        // Revert any address changes.
        const oldAccount = await getAccountService().getAccount(accountKey);
        // Cancelling editing
        return {
            addresses: oldAccount.addresses,
        };
    }

    return null;
}
